var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"floating-panels-stack",class:{ 'floating-panels-stack--with-tasks': _vm.hasTasks }},[_c('MinimizedFileManager',{attrs:{"embedded":""}}),(_vm.showGlobalFloatingButtons)?_c('GlobalFloatingButtons',{attrs:{"embedded":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }